import {
    createColumnInput, createColumnInputNumber
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import {
    createFieldInput,
} from "../../../../../components/input/template-builder/template-builder.logic";

export const createColumns = () => {
    const columns = [
        createColumnInputNumber({
            title: () => i18n.global.t("model.reportMgt.seq"),
            dataIndex: "seq",
            customRender: ({ record }) => <div>{record.seq}</div>,
            width: 60
        }),
        createColumnInput({
            title: () => i18n.global.t("model.reportMgt.title"),
            dataIndex: "title",
            customRender: ({ record }) => <div>{record.title}</div>,
            width: 350
        }),
        createColumnInput({
            title: () => i18n.global.t("model.reportMgt.address"),
            dataIndex: "address",
            customRender: ({ record }) => <div>{record.address}</div>,
            width: 100
        }),
    ]
    return columns
}

export const createFields = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}title`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.reportMgt.title")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.title,
                            "onUpdate:value": value => (model.title = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}address`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.reportMgt.address")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.address,
                            "onUpdate:value": value => (model.address = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}seq`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.reportMgt.seq")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.seq,
                            "onUpdate:value": value => (model.seq = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    })
}